<template>
	<div class="export-popi">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>

		<h1>Export Product Transfer</h1>

		<p class="description">
			This page will export the product transfers.
		</p>

		<div class="datepickerWrapper">
			<b-field label="Starting Date">
				<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="fromDate" icon="calendar-today">
					<button class="button is-danger" @click="fromDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button>
				</b-datepicker>
			</b-field>

			<b-field label="Ending Date">
				<b-datepicker
					:date-formatter="dateFormatter"
					placeholder="Click to select..."
					v-model="toDate"
					icon="calendar-today"
					:min-date="minDate"
					:max-date="maxDate"
				>
					<button class="button is-danger" @click="toDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button></b-datepicker
				>
			</b-field>
		</div>

		<div class="button-container">
			<div class="big-button" @click="exportTransfer()">
				Export
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'exportTransfers',
	data: function() {
		return {
			limit: 20,
			fromDate: null,
			toDate: null,
			minDate: null,
			maxDate: null,
			isLoading: false
		}
	},

	watch: {
		fromDate: function(data) {
			if (data !== null) {
				this.minDate = data
				// Removed as client requested
				// this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.toDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 1)
			} else {
				this.toDate = null
			}
		}
	},

	methods: {
		// Export products on user click
		exportTransfer: async function() {
			// Make sure fromDate is not empty
			if (this.fromDate == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Please enter Starting date'
				})

				return
			}

			this.isLoading = true

			const data = {
				limit: this.limit,
				populate: ['shop_from', 'shop_to', 'operations.product'],
				sort: {
					createdAt: 'desc'
				}
			}

			if (this.fromDate) {
				data.time = {}
				data.time.updatedAt = {
					$gte: this.$moment(this.fromDate)
						.set({ hour: 0 })
						.format('x')
				}

				if (this.toDate) {
					data.time.updatedAt.$lte = this.$moment(this.toDate)
						.set({ hour: 23 })
						.format('x')
				}
			}

			let transfers = []

			const result = await this.$api.getProductTransfers({ data })

			if (result !== undefined && result.data.total > 0) {
				result.data.list.map(data => {
					transfers.push(data)
				})

				// Loop more to get full results
				if (result.data.total > this.limit) {
					var totalLoop = Math.ceil(result.data.total / this.limit)

					var i
					var skip

					// Loop all the pagers
					for (i = 1; i < totalLoop; i++) {
						skip = i * this.limit

						data.skip = skip

						const result = await this.$api.getProductTransfers({ data })

						if (result) {
							result.data.list.map(data => {
								transfers.push(data)
							})
						}
					}
				}

				this.generateCSV(transfers)
			} else {
				this.isLoading = false
				this.$swal.fire({
					icon: 'info',
					title: 'Oops...',
					text: 'Nothing found!'
				})

				return
			}
		},

		generateCSV: function(transfers) {
			let export_csv = ''

			// Include BASE UNIT before QUANTITY
			export_csv += 'CODE,FROM,TO,NAME,BD CODE,BARCODE,DATE,BASE UNIT,QUANTITY,REMARK\r\n'

			// Loop data
			transfers.map(data => {
				const code = data.code ? data.code : ''
				// Map all the transfer products
				data.operations.map(items => {
					// Get packaging base unit if available
					const baseUnit = items.product && items.product.packaging && items.product.packaging.base_unit ? items.product.packaging.base_unit : ''

					const toAdd = [
						code,
						data.shop_from.name,
						data.shop_to.name,
						'"' + items.product.name + '"',
						items.product.bd_code,
						Number(items.product.barcode),
						this.$moment(data.createdAt).format('DD/MM/YY hh:mm a'),
						baseUnit,
						items.stock,
						items.description
					]

					let row = toAdd.join(',')

					export_csv += row + '\r\n'
				})

				export_csv += '\r\n'
			})

			this.isLoading = false

			var csvData = new Blob([export_csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			let filename_date = this.$moment().format('DDMMYYhhmmss')

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Product_Transfer_' + filename_date + '.csv')
			document.body.appendChild(link) // Required for FF

			link.click()
			link.remove()

			// Reset all the fields
			this.fromDate = null
			this.toDate = null
			this.minDate = null
			this.returnNumber = null
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
